/* eslint-disable semi,semi-style */
import React, { FunctionComponent } from 'react';
import { HashRouter as Router, Route, Routes } from 'react-router-dom';
import { useRequest } from 'ahooks';
import { Spin } from 'antd';
import Header, { UserInfo, UserInfoContext } from './components/header/index';
import MicroAppRoute from './MicroAppRoute';
import Index from './components/Index';
import Tools from './components/tools';
import { DirectApply } from './page/direct-apply';
import { Account } from './page/account';
import platforms from './config';
import { login, logout } from '../../util/login';
import { getUserInfoInDirect } from '../index/service';
import './index.scss';
import './antd.less';

interface AppProps {}

const DIRECT_LOCAL_COMPANY = 'open-epower-direct-company-id';
const DIRECT_LOCAL_COMPANY_TYPE = 'open-epower-direct-company-type';

function clearDirectCompanyStorage() {
  localStorage.removeItem(DIRECT_LOCAL_COMPANY);
  localStorage.removeItem(DIRECT_LOCAL_COMPANY_TYPE);
}

const redirectingOut = (
  <Spin spinning tip="正在退出...">
    <div style={{ minHeight: '100vh' }} />
  </Spin>
);

const App: FunctionComponent<AppProps> = () => {
  const { data, loading, error } = useRequest(getUserInfoInDirect);
  console.log('In direct', { data, loading, error });
  let userInfo = undefined;
  if (data) {
    // 需求：当刷新页面时，这个账号在当期桩企（local 中的 id）下没有权限了（即 data.companyIds.includes），则退出登录
    const localId = localStorage.getItem(DIRECT_LOCAL_COMPANY);
    const localIdParsed = localId ? JSON.parse(localId) : null;
    if (localIdParsed && data.companyIds?.length) {
      const isAll = data.companyIds.includes('-1');
      console.log("🚀 ~ App ~ isAll:", isAll, data.companyIds, localIdParsed);
      if (!isAll) {
        if (!data.companyIds.includes(localIdParsed)) {
          console.log("🚀 ~ App ~ 命中登出:", localIdParsed);
          clearDirectCompanyStorage();
          location.href = logout();
          return redirectingOut;
        }
      }
    } else if (localIdParsed && data.companyIds?.length === 0) {
      // 无桩企权限时只清理 stale localId，不强制登出（支持 directApply 入驻页直达）
      console.log("🚀 ~ App ~ 清理无效桩企缓存:", localIdParsed);
      clearDirectCompanyStorage();
    }
    userInfo = Object.assign(
      {
        loginError: false,
      },
      data,
    );
  } else if (error) {
    userInfo = Object.assign(
      {},
      {
        loginError: true,
      },
    );
  }
  window.Login = login;
  window.loginPending = loading;
  window.loginInfo = loading ? { loginPending: true } : userInfo;

  return (
    <Spin spinning={loading} indicator={null} wrapperClassName="app-userinfo-spin">
      <UserInfoContext.Provider value={userInfo}>
        <Router>
          <Header user={data} />
          <Routes>
            <Route path="/" element={<Index />} />
            <Route path="/comming" element={<Tools type="comming" />} />
            <Route path="/needauth" element={<Tools type="needauth" />} />
            {platforms
              .filter(item => item.nebulaModule)
              .map((item, key) => (
                <Route
                  key={key}
                  path={item.path + (item.exact === false ? '/*' : '')}
                  element={<MicroAppRoute source={item} />}
                />
              ))}
            <Route path="/directApply" element={<DirectApply />} />
            <Route path="/account/profile/*" element={<Account />} />
          </Routes>
        </Router>
      </UserInfoContext.Provider>
    </Spin>
  );
};

export default App
